import React from "react";

const YouTubeEmbed = ({ url }) => {
  const getYouTubeID = (url) => {
    const regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);

    return match && match[2].length === 11 ? match[2] : null;
  };

  const videoId = getYouTubeID(url);

  return (
    <div>
      {videoId && (
        <iframe
          width="100%"
          height="700"
          src={`https://www.youtube.com/embed/${videoId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded YouTube"
        />
      )}
    </div>
  );
};

export default YouTubeEmbed;
